export default "__VITE_ASSET__BaX6Mlo___"